export default {
  StatisticalAnalysis: 'Statistical Analysis',
  BusinessDataAnalysis: 'Business Data Analysis',
  GatewayServiceMonitor: 'Gateway Service Monitoring',
  NetworkQualityMonitor: 'Network Quality Monitoring',
  NearlyHour: (hour: number) => `Nearly ${hour} hours`,
  SearchGatewayCpePlaceholder: 'Search for device id/device name/gateway name/branch',
  TotalUpStream: 'Total peak bandwidth - upstream',
  TotalDownStream: 'Total peak bandwidth - downstream',
  Bandwidth: 'Bandwidth',
  BandwidthUtilization: 'Bandwidth usage',
  BarChartTitle: 'Branch traffic usage（top20）',
  NICThroughput: 'NIC Throughput',
  NetworkCardPacketLoss: 'NIC packet loss',
  EquipmentLoad: 'Device load',
  CPUUsage: 'CPU usage',
  MemoryUsage: 'Memory usage',
  DiskUsage: 'Disk usage',
  SearchSourceDevice: 'Search source device number/device alias/gateway number/branch office',
  SearchTargetDevice: 'Search target device number/device alias/gateway number/branch office',
  AllProtocol: 'All protocol',
  AlarmList: 'Alert events',
  SelectPhysical: 'Select physical port',
}